import { render, staticRenderFns } from "./sasalink.vue?vue&type=template&id=712bb386&"
import script from "./sasalink.vue?vue&type=script&lang=js&"
export * from "./sasalink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports